import { render, staticRenderFns } from "./allocate-puppy-container.vue?vue&type=template&id=24f5c86e&scoped=true&lang=pug"
import script from "./allocate-puppy-container.js?vue&type=script&lang=js&external"
export * from "./allocate-puppy-container.js?vue&type=script&lang=js&external"
import style0 from "./allocate-puppy-container.vue?vue&type=style&index=0&id=24f5c86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5c86e",
  null
  
)

export default component.exports